
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.md?watch=parent';
    export const demoIndex = {
  ids: ["liquid-demo-common","liquid-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Liquid" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.md?type=demo')
};